module.exports = __webpack_public_path__ + "static/media/giftcard.45f5c4b2.svg";